// extracted by mini-css-extract-plugin
export default {"teamcardParent":"Lawyer_teamcardParent__w1Bjg","lawyer":"Lawyer_lawyer__tUOW4"};